<script setup lang="ts">
const props = defineProps({
  options: {
    type: Array<string>,
    required: true,
  },
  selectedOption: {
    type: String,
    required: true,
  },
})
const emits = defineEmits(['change'])

const selectOption = (option: string) => emits('change', option)
</script>
<template>
  <div class="slider">
    <template v-for="option in props.options" :key="option">
      <div
        :class="{ active: props.selectedOption === option }"
        @click="selectOption(option)"
        v-ga-event="{ sectionContent: option }"
      >
        {{ option }}
      </div>
    </template>
    <div class="selector" :class="{ right: props.selectedOption === props.options[1] }"></div>
  </div>
</template>
<style lang="scss" scoped>
.slider {
  cursor: pointer;
  text-align: center;
  position: relative;
  width: pxToRem(445.575px);
  height: pxToRem(40.325px);
  background-color: #231d17;
  border-radius: pxToRem(25px);
  margin: 0 auto;
  margin-top: pxToRem(25px);
  color: #7c7c7c;
  font-family: Glegoo;
  font-weight: bold;
  font-size: pxToRem(18.075px);
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding: 0 pxToRem(25px);
  > div {
    width: 50%;
    z-index: 2;
    transition: all 0.2s linear;
    &:first-child {
      padding-right: pxToRem(12.5px);
    }
    &:nth-child(2) {
      padding-left: pxToRem(25px);
    }
    &.active,
    &:hover {
      color: #fff;
    }
  }
  .selector {
    z-index: 1;
    position: absolute;
    height: pxToRem(32.25px);
    background-color: #4e79eb;
    border-radius: pxToRem(25px);
    left: pxToRem(4.5px);
    &.right {
      left: pxToRem(218.75px);
    }
  }
}
@media #{$tablet} {
  div.slider {
    width: pxToRemTablet(317.908px);
    height: pxToRemTablet(40.014px);
    font-size: pxToRemTablet(18.012px);
    padding: 0;
    justify-content: space-between;
    margin: pxToRemTablet(28.5px) 0;
    > div {
      width: auto;
      &:first-child {
        padding-left: pxToRemTablet(24.7px);
        padding-right: 0;
      }
      &:nth-child(2) {
        padding-left: 0;
        padding-right: pxToRemTablet(13.3px);
      }
    }
    .selector {
      height: pxToRemTablet(31.996px);
      left: pxToRemTablet(3.8px);
      width: pxToRemTablet(142.12px);
      &.right {
        width: pxToRemTablet(165.908px);
        left: pxToRemTablet(148.2px);
      }
    }
  }
}
</style>
